import { CurrencyInput } from '@framework/form/inputs/CurrencyInput.tsx';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem.tsx';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { getWidgetProps } from '../common/util/getWidgetProps.ts';
import { type ICurrencyWidget } from './ICurrencyWidget.ts';

export interface ICurrencyWidgetComponentProps
  extends IWidgetComponentProps<ICurrencyWidget> {}

export function CurrencyWidgetComponent(props: ICurrencyWidgetComponentProps) {
  const options = getWidgetProps(props);
  const decimalPlaces = props.widget.decimalSize ?? undefined;

  return (
    <ConfigFormItem
      name={options.name}
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={
        options.helpText ? (
          <RichTextAdvancedRender inline text={options.helpText} />
        ) : undefined
      }
      layout={{ hideVisualLabel: options.hideLabel }}
      readonly={options.readonly}
      widget={props.widget}
    >
      <CurrencyInput
        readOnly={props.readonly}
        name={options.name}
        placeholder={options.placeholder}
        value={options.value}
        tabIndex={options.preview ? -1 : undefined}
        decimalPlaces={decimalPlaces}
      />
    </ConfigFormItem>
  );
}
